import React from 'react'

const IconLogout = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2001_297)">
    <path d="M26 2H34C35.0609 2 36.0783 2.42143 36.8284 3.17157C37.5786 3.92172 38 4.93913 38 6V34C38 35.0609 37.5786 36.0783 36.8284 36.8284C36.0783 37.5786 35.0609 38 34 38H26" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.9998 29.9998L25.9998 19.9998L15.9998 9.99976" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M26 20H2" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_2001_297">
    <rect width="40" height="40" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  )
}

export default IconLogout